export interface ThemeState {
    realTheme: 'light' | 'dark'
    theme: 'light' | 'dark' | 'system'
}

const state: ThemeState = {
    realTheme: 'light',
    theme: 'system'
}

const getters = {
    theme: (state: ThemeState) => state.theme,
    realTheme: (state: ThemeState) => state.realTheme,
    isDarkTheme: (state: ThemeState) => state.realTheme === 'dark',
    isLightTheme: (state: ThemeState) => state.realTheme === 'light'
}

const mutations = {
    SET_THEME(state: ThemeState, theme: 'light' | 'dark' | 'system') {
        state.theme = theme
    },
    SET_REAL_THEME(state: ThemeState, realTheme: 'light' | 'dark') {
        state.realTheme = realTheme
    }
}

const actions = {
    // 设置主题
    setTheme({ commit, dispatch }: any, theme: 'light' | 'dark' | 'system') {
        commit('SET_THEME', theme)
        dispatch('updateRealTheme')
        if (true) localStorage.setItem('theme', state.theme)
    },

    // 初始化主题
    initTheme({ dispatch }: any) {
        const savedTheme = typeof window !== 'undefined'
            ? localStorage.getItem('theme') as 'light' | 'dark' | 'system' | null
            : null

        if (savedTheme) {
            dispatch('setTheme', savedTheme)
        } else {
            dispatch('setTheme', 'system')
        }

        // 测试用，先固定
        dispatch('setTheme', 'light')
    },
    updateRealTheme({ commit, state }: any) {
        if (state.theme === 'system') {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
            commit('SET_REAL_THEME', prefersDark ? 'dark' : 'light')
        } else {
            commit('SET_REAL_THEME', state.theme)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
